import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './NumberOfTaxiTableDash.css';

const NumberOfTaxiTableDash = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [editRowId, setEditRowId] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchData = async () => {
    try {
      const [rentRes, sellRes] = await Promise.all([
        axios.get('/api/numbertaxiforrent/all'),
        axios.get('/api/numbertaxiforsale/all'),
      ]);

      const rentData = rentRes.data.data || [];
      const sellData = sellRes.data.data || [];

      const combinedData = [
        ...rentData.map(item => ({ ...item, Source: 'SqlRent' })),
        ...sellData.map(item => ({ ...item, Source: 'SqlSell' })),
      ];

      setData(combinedData);
      setLoading(false);
    } catch (error) {
      console.error('❌ שגיאה בשליפת נתונים:', error);
      setLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return '-';
    const date = new Date(isoDate);
    return date.toLocaleDateString('he-IL');
  };

  const formatPrice = (value) => {
    if (!value) return '';
    const number = parseFloat(value.toString().replace(/[^\d.]/g, ''));
    return isNaN(number) ? value : number.toLocaleString('he-IL') + ' ₪';
  };

  const handleDelete = async (id, source) => {
    if (!window.confirm("האם אתה בטוח שברצונך למחוק את השורה הזו?")) return;

    try {
      const response = await axios.delete("/api/numbertaxiforrent/delete", {
        data: { id, source }
      });

      if (response.data.success) {
        alert("השורה נמחקה בהצלחה");
        fetchData();
      } else {
        alert("מחיקה נכשלה");
      }
    } catch (error) {
      console.error("❌ שגיאה במחיקה:", error);
      alert("שגיאה במחיקת הנתון");
    }
  };

  const handleEdit = (item) => {
    setEditRowId(item.id);
    setEditFormData({ ...item });
  };

  const handleEditChange = (e) => {
    setEditFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSaveEdit = async () => {
    try {
      const formattedPrice = formatPrice(editFormData.Price);

      const response = await axios.post("/api/numbertaxiforrent/edit", {
        ...editFormData,
        id: editRowId,
        source: editFormData.Source,
        Price: formattedPrice,
      });

      if (response.data.success) {
        alert("השורה עודכנה בהצלחה");
        setEditRowId(null);
        setEditFormData({});
        fetchData();
      } else {
        alert("העדכון נכשל");
      }
    } catch (error) {
      console.error("❌ שגיאה בעריכה:", error);
      alert("שגיאה בעדכון הנתון");
    }
  };

  const filteredData = data.filter(item => {
    if (filter === "all") return true;
    return item.Source === filter;
  });

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <div>טוען נתונים...</div>;

  return (
    <div className="NumberOfTaxiTableDash_container">
      <h2 className="NumberOfTaxiTableDash_title">רשימת כל הזכויות</h2>

      <div className="NumberOfTaxiTableDash_filterButtons">
        <button className="NumberOfTaxiTableDash_button" onClick={() => setFilter("all")}>הצג הכל</button>
        <button className="NumberOfTaxiTableDash_button" onClick={() => setFilter("SqlRent")}>להשכרה בלבד</button>
        <button className="NumberOfTaxiTableDash_button" onClick={() => setFilter("SqlSell")}>למכירה בלבד</button>
      </div>

      {isMobile ? (
  <div className="NumberOfTaxiTableDash_mobileList">
    {filteredData.map(item => (
      <div key={`${item.id}-${item.Source}`} className={`NumberOfTaxiTableDash_card ${editRowId === item.id ? 'editing' : ''}`}>
        {editRowId === item.id ? (
          <>
            <div><strong>שם:</strong> <input className="NumberOfTaxiTableDash_input" name="Name" value={editFormData.Name} onChange={handleEditChange} /></div>
            <div><strong>סוג:</strong>
              <select className="NumberOfTaxiTableDash_select" name="Type" value={editFormData.Type} onChange={handleEditChange}>
                <option value="להשכרה">להשכרה</option>
                <option value="למכירה">למכירה</option>
              </select>
            </div>
            <div><strong>תאריך פינוי:</strong>
              <input className="NumberOfTaxiTableDash_input" type="date" name="Date" value={editFormData.Date?.split('T')[0] || ''} onChange={handleEditChange} />
            </div>
            <div><strong>מיידי:</strong>
              <select className="NumberOfTaxiTableDash_select" name="Immediately" value={editFormData.Immediately} onChange={handleEditChange}>
                <option value="כן">כן</option>
                <option value="לא">לא</option>
              </select>
            </div>
            <div><strong>מחיר:</strong> <input className="NumberOfTaxiTableDash_input" name="Price" value={editFormData.Price} onChange={handleEditChange} /></div>
            <div><strong>טלפון:</strong> <input className="NumberOfTaxiTableDash_input" name="Phone" value={editFormData.Phone} onChange={handleEditChange} /></div>
            <div><strong>מקור:</strong> {item.Source}</div>

            <div className="NumberOfTaxiTableDash_cardButtons">
              <button className="NumberOfTaxiTableDash_buttonSave" onClick={handleSaveEdit}>💾 שמור</button>
              <button className="NumberOfTaxiTableDash_buttonCancel" onClick={() => setEditRowId(null)}>❌ ביטול</button>
            </div>
          </>
        ) : (
          <>
            <div><strong>שם:</strong> {item.Name}</div>
            <div><strong>סוג:</strong> {item.Type}</div>
            <div><strong>תאריך פינוי:</strong> {formatDate(item.Date)}</div>
            <div><strong>מיידי:</strong> {item.Immediately}</div>
            <div><strong>מחיר:</strong> {formatPrice(item.Price)}</div>
            <div><strong>טלפון:</strong> {item.Phone}</div>
            <div><strong>מקור:</strong> {item.Source}</div>
            <div className="NumberOfTaxiTableDash_cardButtons">
              <button className="NumberOfTaxiTableDash_buttonEdit" onClick={() => handleEdit(item)}>✏️ ערוך</button>
              <button className="NumberOfTaxiTableDash_buttonDelete" onClick={() => handleDelete(item.id, item.Source)}>🗑️ מחק</button>
            </div>
          </>
        )}
      </div>
    ))}
  </div>
      ) : (
        <table className="NumberOfTaxiTableDash_table">
          <thead className="NumberOfTaxiTableDash_thead">
            <tr className="NumberOfTaxiTableDash_tr">
              <th className="NumberOfTaxiTableDash_th">שם</th>
              <th className="NumberOfTaxiTableDash_th">סוג</th>
              <th className="NumberOfTaxiTableDash_th">תאריך פינוי</th>
              <th className="NumberOfTaxiTableDash_th">מיידי</th>
              <th className="NumberOfTaxiTableDash_th">מחיר</th>
              <th className="NumberOfTaxiTableDash_th">טלפון</th>
              <th className="NumberOfTaxiTableDash_th">מקור</th>
              <th className="NumberOfTaxiTableDash_th">פעולות</th>
            </tr>
          </thead>
          <tbody className="NumberOfTaxiTableDash_tbody">
            {filteredData.map((item) => (
              <tr key={`${item.id}-${item.Source}`} className={`NumberOfTaxiTableDash_tr ${editRowId === item.id ? 'NumberOfTaxiTableDash_editingRow' : ''}`}>
                {editRowId === item.id ? (
                  <>
                    <td className="NumberOfTaxiTableDash_td"><input className="NumberOfTaxiTableDash_input" name="Name" value={editFormData.Name} onChange={handleEditChange} /></td>
                    <td className="NumberOfTaxiTableDash_td">
                      <select className="NumberOfTaxiTableDash_select" name="Type" value={editFormData.Type} onChange={handleEditChange}>
                        <option value="להשכרה">להשכרה</option>
                        <option value="למכירה">למכירה</option>
                      </select>
                    </td>
                    <td className="NumberOfTaxiTableDash_td">
                      <input type="date" className="NumberOfTaxiTableDash_input" name="Date" value={editFormData.Date?.split('T')[0] || ''} onChange={handleEditChange} />
                    </td>
                    <td className="NumberOfTaxiTableDash_td">
                      <select className="NumberOfTaxiTableDash_select" name="Immediately" value={editFormData.Immediately} onChange={handleEditChange}>
                        <option value="כן">כן</option>
                        <option value="לא">לא</option>
                      </select>
                    </td>
                    <td className="NumberOfTaxiTableDash_td"><input className="NumberOfTaxiTableDash_input" name="Price" value={editFormData.Price} onChange={handleEditChange} /></td>
                    <td className="NumberOfTaxiTableDash_td"><input className="NumberOfTaxiTableDash_input" name="Phone" value={editFormData.Phone} onChange={handleEditChange} /></td>
                    <td className="NumberOfTaxiTableDash_td">{item.Source}</td>
                    <td className="NumberOfTaxiTableDash_td">
                      <button className="NumberOfTaxiTableDash_buttonSave" onClick={handleSaveEdit}>💾 שמור</button>
                      <button className="NumberOfTaxiTableDash_buttonCancel" onClick={() => setEditRowId(null)}>❌ ביטול</button>
                    </td>
                  </>
                ) : (
                  <>
                    <td className="NumberOfTaxiTableDash_td">{item.Name}</td>
                    <td className="NumberOfTaxiTableDash_td">{item.Type}</td>
                    <td className="NumberOfTaxiTableDash_td">{formatDate(item.Date)}</td>
                    <td className="NumberOfTaxiTableDash_td">{item.Immediately}</td>
                    <td className="NumberOfTaxiTableDash_td">{item.Price}</td>
                    <td className="NumberOfTaxiTableDash_td">{item.Phone}</td>
                    <td className="NumberOfTaxiTableDash_td">{item.Source}</td>
                    <td className="NumberOfTaxiTableDash_td">
                      <button className="NumberOfTaxiTableDash_buttonEdit" onClick={() => handleEdit(item)}>✏️ ערוך</button>
                      <button className="NumberOfTaxiTableDash_buttonDelete" onClick={() => handleDelete(item.id, item.Source)}>🗑️ מחק</button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default NumberOfTaxiTableDash;
